import { t } from "i18next";
import { useContext } from "react";

import { InfoCircleOutlined } from "@ant-design/icons";
import { Flex, Tooltip } from "antd";
import { Table } from "../../../../../components/Table/Table";
import {
  renderOznakaSaKolicinomSerijskiBrojevi,
  renderOznakeSaKolicinom,
  renderOznakeSaKolicinomPoPakovanju,
} from "../../../../../modules/obligee/periodicReports/periodicReport.functions";
import { PeriodicReportsContext } from "../../../../../modules/obligee/periodicReports/periodicReports.context";
import { CoffeeReport } from "../../../../../modules/obligee/periodicReports/periodicReports.types";
import { useScreenResize } from "../../../../../utils/useScreenResize";

export const CoffeeTable = () => {
  const { periodicReports } = useContext(PeriodicReportsContext);
  const { width } = useScreenResize();

  const colDefCoffee = [
    {
      title: t("PERIODICNI_IZVESTAJI.BROJ_I_DATUM_ZAMK"),
      children: [
        {
          title: "1",
          width: "240px",
          fixed: "left",
          dataIndex: "brojIDatumZahteva",
        },
      ],
    },
    {
      title: t("PERIODICNI_IZVESTAJI.SLOVNA_OZNAKA_I_KOLICINA_KAFA"),
      children: [
        {
          title: "2",
          width: "240px",
          fixed: "left",
          dataIndex: "slovnaOznakaIKolicinaPreuzetihMarkica",
          render: (_: string, record: CoffeeReport) => (
            <Flex gap={10} vertical>
              {record.slovnaOznakaIKolicinaPreuzetihMarkica?.map((oznaka) => {
                return oznaka ? <span>{oznaka}</span> : <br />;
              })}
            </Flex>
          ),
        },
      ],
    },
    {
      title: t("PERIODICNI_IZVESTAJI.OZNAKA_SERIJE_I_SERIJSKI_BROJ_KAFA"),
      children: [
        {
          title: "3",
          width: "240px",
          fixed: "left",
          dataIndex: "oznakaSerijeISerijskiBrojPreuzetihMarkica",
          render: (_: string, record: CoffeeReport) => (
            <Flex gap={10} vertical>
              {record.oznakaSerijeISerijskiBrojPreuzetihMarkica?.map(
                (oznaka) => {
                  return oznaka ? <span>{oznaka}</span> : <br />;
                }
              )}
            </Flex>
          ),
        },
      ],
    },
    {
      title: (
        <Tooltip title={t("PERIODICNI_IZVESTAJI.NAPOMENA_KOLONA_4")}>
          {t("PERIODICNI_IZVESTAJI.STANJE_NERAZDUZENIH_MARKICA")}{" "}
          <InfoCircleOutlined />
        </Tooltip>
      ),
      width: "240px",
      children: [
        {
          title: "4",
          width: "240px",
          render: (record: CoffeeReport) =>
            renderOznakeSaKolicinom(
              record.brojNeutrosenihMarkicaPrethodniKvartal
            ),
        },
      ],
    },
    {
      title: (
        <Tooltip title={t("PERIODICNI_IZVESTAJI.NAPOMENA_KOLONA_5")}>
          {t("PERIODICNI_IZVESTAJI.BROJ_ISKORISCENIH_MARKICA_KAFA")}{" "}
          <InfoCircleOutlined />
        </Tooltip>
      ),
      children: [
        {
          title: "5",
          width: "240px",
          render: (record: CoffeeReport) =>
            renderOznakeSaKolicinom(
              record.brojIskoriscenihMarkicaIzProizvodnje
            ),
        },
      ],
    },
    {
      title: (
        <Tooltip title={t("PERIODICNI_IZVESTAJI.NAPOMENA_KOLONA_6")}>
          {t("PERIODICNI_IZVESTAJI.BROJ_ISKORISCENIH_MARKICA_PROMET_KAFA")}{" "}
          <InfoCircleOutlined />
        </Tooltip>
      ),
      children: [
        {
          title: "6",
          width: "240px",
          render: (record: CoffeeReport) =>
            renderOznakeSaKolicinom(record.brojIskoriscenihMarkicaIzUvoza),
        },
      ],
    },
    {
      title: (
        <Tooltip title={t("PERIODICNI_IZVESTAJI.NAPOMENA_KAFA_7")}>
          {t("PERIODICNI_IZVESTAJI.KOLICINA_KAFE_PREMA_VRSTI")}{" "}
          <InfoCircleOutlined />
        </Tooltip>
      ),
      children: [
        {
          title: "7",
          width: "240px",
          render: (record: CoffeeReport) =>
            renderOznakeSaKolicinomPoPakovanju(record.pakovanjaAmbalaza),
        },
      ],
    },
    {
      title: (
        <Tooltip title={t("PERIODICNI_IZVESTAJI.NAPOMENA_KOLONA_8")}>
          {t("PERIODICNI_IZVESTAJI.BROJ_VRACENIH_OSTECENIH_MARKICA_KAFA")}{" "}
          <InfoCircleOutlined />
        </Tooltip>
      ),
      children: [
        {
          title: "8",
          width: "240px",
          render: (record: CoffeeReport) =>
            renderOznakaSaKolicinomSerijskiBrojevi(
              record.brojOstecenihVidljivihMarkica
            ),
        },
      ],
    },
    {
      title: t(
        "PERIODICNI_IZVESTAJI.BROJ_VRACENIH_OSTECENIH_MARKICA_NEVIDLJIVI_KAFA"
      ),
      children: [
        {
          title: "9",
          width: "240px",
          render: (record: CoffeeReport) =>
            renderOznakeSaKolicinom(
              record.brojOstecenihNevidljivihMarkica,
              true
            ),
        },
      ],
    },
    {
      title: t("PERIODICNI_IZVESTAJI.STANJE_KAFA"),
      children: [
        {
          title: "10",
          width: "260px",
          render: (record: CoffeeReport) =>
            renderOznakaSaKolicinomSerijskiBrojevi(
              record.brojNerazduzenihMarkicaISerijskiBrojNaKraju
            ),
        },
      ],
    },
  ];

  const scrollConfig =
    width < 992 ? undefined : [".ant-tabs-nav", "#coffee_table", "#periodic"];

  return (
    <div>
      <div id="coffee_table" style={{ display: "flex" }}>
        <h2 className="alignCenter">
          {t("AKCIZNE_MARKICE.KAFA_VELIKO").toUpperCase()}
        </h2>
      </div>
      <Table
        columns={colDefCoffee}
        scrollConfig={scrollConfig}
        dataSource={periodicReports.coffeeReport}
        name="periodicni-izvestaji-tabela-kafa"
      />
    </div>
  );
};
